import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ReturnsPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="bg-secondary-50 py-16 px-6 text-center">
          <p className="text-xs tracking-[0.3em] text-primary-500 mb-3 uppercase"
            style={{ fontFamily: "var(--font-heading)" }}>
            Returns
          </p>
          <h1 className="text-4xl md:text-6xl font-light text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}>
            返品・交換
          </h1>
        </div>

        <div className="max-w-3xl mx-auto px-6 py-14 space-y-6">
          <div className="border border-background-200 rounded-xl p-5">
            <p className="text-sm text-foreground-900 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
              お客様都合の返品・交換
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
              お客様都合による返品・交換は承っておりません。
            </p>
          </div>
          <div className="border border-background-200 rounded-xl p-5">
            <p className="text-sm text-foreground-900 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
              不良品・誤発送の場合
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
              不良品または当店の誤発送の場合のみ、交換にて対応いたします。お問い合わせよりご連絡ください。
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
